import Vue from "vue"
import BasicSvg from "../../components/svgIcon/BasicSvg.vue"

Vue.component("BasicSvg", BasicSvg)

const requireAll = requireContext => requireContext.keys().map(requireContext)
const req = require.context("./svg", false, /\.svg$/)
requireAll(req)